import { useModelContext } from '@app/contexts/model';
import { useStorageConfirmTranslateContext } from '@app/modules/ConfirmTranslate/contexts/storage';
import { ModalError } from '@app/modules/Translate/components/ModalRejectFiles/ModalError';
import { ModalReject } from '@app/modules/Translate/components/ModalRejectFiles/ModalReject';
import { ModalSuccess } from '@app/modules/Translate/components/ModalRejectFiles/ModalSuccess';
import { useStorageTranslateContext } from '@app/modules/Translate/contexts/storage';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconButton } from '@mui/material';
import { observer } from 'mobx-react';
import React, { FunctionComponent } from 'react';

interface IRejectTranslateProps {}

export const RejectTranslate: FunctionComponent<IRejectTranslateProps> = observer<FunctionComponent<IRejectTranslateProps>>(function (props) {
    const { translateStore } = useStorageTranslateContext();
    const { authorizationModel } = useModelContext();
    const { confirmTranslateStore } = useStorageConfirmTranslateContext();

    const user = authorizationModel.user.get();

    let fileToReject = confirmTranslateStore.fileId;
    let disabled = !fileToReject;

    const onClick = () => {
        if (confirmTranslateStore.fileId != '' && confirmTranslateStore.fileId.length != 2) {
            translateStore.handleOpenReject();
        } else {
            translateStore.handleOpenRejectModalError();
        }
    };

    return (
        <>
            {user.user.approval && (
                <IconButton disabled={disabled} className='featureButtons__i fa fa-trash-o' aria-hidden='true' title='Reject translation' onClick={onClick}>
                    <FontAwesomeIcon icon={faTrash} />
                </IconButton>
            )}
            <ModalReject />
            <ModalSuccess />
            <ModalError />
        </>
    );
});
